document.addEventListener('DOMContentLoaded', function() {

  const clickCountMap = new Map();
  const clickMeButtons = document.querySelectorAll('.multiple-click-on-responsive');

  clickMeButtons.forEach(button => {
    clickCountMap.set(button, 0);
    button.addEventListener('click', function(event) {
      if (clickCountMap.get(button) === 0) {
        event.preventDefault();
      }
      const currentCount = clickCountMap.get(button);
      clickCountMap.set(button, currentCount + 1);
      if (currentCount === 0) {
      } else if (currentCount === 1) {
        clickCountMap.set(button, 0);
        console.log("click Second time");
      }
    });
  });

  // const quantityInterval = setInterval(calenderQuantity, 1000);
  // function calenderQuantity(){
  //     let multiBook = document.querySelector('.flatpickr-innerContainer + .izyMultiBook');
  //     let dayElements = document.querySelectorAll('.flatpickr-day');
  //     dayElements.forEach(function(dayElement) {
  //     if(!multiBook.querySelector('.flatpickr-innerContainer + .izyMultiBook .izyMultiQty').classList.contains('qty-wrapper')){
  //                 if (dayElement.classList.contains('selected')) { 
  //                 let izyMultiQtyElement = multiBook.querySelector('.flatpickr-innerContainer + .izyMultiBook .izyMultiQty');
  //                   izyMultiQtyElement.classList.add('qty-wrapper');
  //               }
  //     }
  //     });
  // }
  // function calenderQuantityClear() {
  //   clearInterval(quantityInterval);
  // }

  const quantityInterval = setInterval(calenderQuantity);
  function calenderQuantity(){
      let dayElements = document.querySelectorAll('.flatpickr-day');
      dayElements.forEach(function(dayElement) {
          if (dayElement.classList.contains('selected')) { 
            document.querySelector('.flatpickr-calendar').classList.add('qty-wrapper');
          }
      });
  }
  setInterval(function () {
    if(document.querySelector('#izyButtons .izyclear')){
      document.querySelector('#izyButtons .izyclear').addEventListener('click', function() {
         document.querySelector('.flatpickr-calendar').classList.remove('qty-wrapper');
      })
    }
  });

  var section = document.querySelector('.testimonial-slider');
  var scrollButton = document.getElementById('scrollButton');

  scrollButton.addEventListener('click', function() {
    section.scrollIntoView({ behavior: 'smooth' });
  });

});




